import MemberPassword from './MemberPassword.component';

export default MemberPassword;
